import { Controller } from "@hotwired/stimulus";

export default class SessionCheckController extends Controller {
  connect() {
    this.handlePageShow = this.handlePageShow.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

    window.addEventListener("pageshow", this.handlePageShow);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  disconnect() {
    window.removeEventListener("pageshow", this.handlePageShow);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  handlePageShow(event) {
    this.checkSession();
  }

  handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.checkSession();
    }
  }

  checkSession() {
    fetch("/sessions/status", {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store"
    }).then((response) => {
      if (response.redirected) {
        globalThis.location.href = response.url;
      }
    });
  }
}
